import React from 'react';
import Box from '@mui/material/Box';

import { CheckboxWithLabel, Textfield } from '../../../components';
import { InputAdornment } from '@mui/material';
import { useState } from 'react';

export function DonationMessage({ showMessageTextArea, handleInputChange }) {
	const [message, setMessage] = useState('');

	const handleChange = (e) => {
		if (e.target.value.length <= 500) {
			setMessage(e.target.value);
			handleInputChange(e);
		}
	};
	return (
		<Box sx={{ pt: 1 }}>
			<CheckboxWithLabel label="Leave a message with your donation" nameAndId="leaveAMessageWithDonation" handleCheck={handleInputChange} />
			{showMessageTextArea && (
				<div id="goodluck_div">
					<Textfield
						id="goodLuckMessage"
						name="goodLuckMessage"
						label="Your message"
						onChange={handleChange}
						margin="dense"
						multiline
						rows={4}
						fullWidth
						inputProps={{
							maxLength: 500,
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment
									position="end"
									sx={{
										position: 'absolute',
										top: '25px',
										right: '15px',
										fontSize: '11px',
										color: 'grey',
									}}
								>
									{message.length}/500
								</InputAdornment>
							),
						}}
						sx={{
							'& .MuiOutlinedInput-root': {
								borderRadius: '8px',
								paddingTop: '20px',
							},
						}}
					/>
				</div>
			)}
		</Box>
	);
}
